import { render } from "./MsLogin.vue?vue&type=template&id=0a9167d4&scoped=true&lang=html"
import script from "./MsLogin.vue?vue&type=script&lang=js"
export * from "./MsLogin.vue?vue&type=script&lang=js"

import "./MsLogin.vue?vue&type=style&index=0&id=0a9167d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9167d4"]])

export default __exports__